export const state = {
  Allcustomers: [],
};
export const mutations = {
  Save_Customers(state, customersList) {
    // state.tokenID = token;
    state.Allcustomers = customersList;
  },
};

export const getters = {
  CustomersList(state) {
    return state.Allcustomers;
  },
};
